import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { imageConfig } from '../../../../config/config'
import { getText } from '../../../../utils/util'
import KLine3 from '../kline3'

export default function KineCenter({ nowTab, setIndex, setType, timeindex, settimeindex, ctmarketlist }) {
  const navigate = useNavigate()
  const { t: translate } = useTranslation()
  const times = ['Time', '1M', '5M', '15M', '30M', '1H', '1D', '7D']
  
  const getTimesArray = () => {
    return times.map((time, index) => (
      <li
        key={index}
        className={`px-4 py-2.5 text-sm font-medium cursor-pointer transition-all duration-200 ease-in-out
          ${timeindex === index + 1 
            ? 'text-neutral-50 border-b-2 border-primary' 
            : 'text-neutral-400 hover:text-neutral-800'
          }`}
        onClick={() => settimeindex(index + 1)}>
        {time}
      </li>
    ))
  }

  return (
    <div className="flex flex-col h-full bg-neutral-900">
      <div className="border-b border-neutral-800">
        <ul className="flex items-center h-12 px-2 overflow-x-auto no-scrollbar">
          {getTimesArray()}
        </ul>
      </div>
      <div className="flex-1 min-h-0 bg-white">
        <div className="w-full h-full">
          <KLine3
            ctmarketlist={ctmarketlist}
            nowTab={nowTab}
            setIndex={setIndex}
            setType={setType}
            timeindex={timeindex}
            settimeindex={settimeindex}
          />
        </div>
      </div>
    </div>
  )
}
